/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_TagsInputs */



/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Editor_Table_Column_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_tags = /** @type {((inputs?: Editor_Table_Column_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "it") return /** @type {LocalizedString} */ ("Etichette")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Теги")
	if (locale === "es") return /** @type {LocalizedString} */ ("Etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Etiquetas")
	return /** @type {LocalizedString} */ ("Tags")
});